import { ALL_FLAVOURS, ALL_TEXTURES } from "../constants/defaults";
import type { TCatFormDataInput } from "../schemas/cat-form-data.schema";

function backfillCatPreferences(
  cat: Pick<TCatFormDataInput, "body" | "diet">,
): void {
  const hasFlavours = Boolean(cat.diet?.preferences?.flavours?.length);
  const hasTextures = Boolean(cat.diet?.preferences?.textures?.length);

  if (!hasFlavours || !hasTextures) {
    cat.diet = {
      ...cat.diet,
      preferences: {
        ...cat.diet?.preferences,
        flavours: hasFlavours ? cat.diet?.preferences?.flavours : [ ...ALL_FLAVOURS ],
        textures: hasTextures ? cat.diet?.preferences?.textures : [ ...ALL_TEXTURES ],
      },
    };
  }
}

/**
 * At hydration time, if a cat was on or past the /fitness step (has eatingHabits set)
 * but has no flavour/texture preferences, backfill with "select all" defaults.
 * This prevents returning users from being routed back to the new preference
 * pages when they had already progressed beyond them.
 */
export function prefillMissingPreferences<
  T extends { cats: Record<string, Pick<TCatFormDataInput, "body" | "diet">> },
>(data: T): T {
  for (const cat of Object.values(data.cats)) {
    if (cat.body?.activityLevel) {
      backfillCatPreferences(cat);
    }
  }

  return data;
}
